import {
  StepConnector,
  StepIconProps,
  StepLabel,
  stepConnectorClasses,
  styled,
  useTheme,
} from "@mui/material";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";
import ActiveStepIcon from "./components/ActiveStepIcon";
import CompletedStepIcon from "./components/CompletedStepIcon";
import DarkActiveStepIcon from "./components/DarkActiveStepIcon";
import DarkGiftIcon from "./components/DarkGiftIcon";
import DeactiveStepIcon from "./components/DeactiveStepIcon";
import GiftIcon from "./components/GiftIcon";

const steps = ["اطلاعات شرکت", "تایید شماره همراه", "دریافت جایزه"];

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 26,
    left: "calc(-50% + 30px)",
    right: "calc(50% + 30px)",
  },

  [theme.breakpoints.down("md")]: {
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 13,
      left: "calc(-50% + 15px)",
      right: "calc(50% + 15px)",
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderWidth: 3,
      borderColor: theme.palette.mode === "dark" ? "#5460A8" : "#0E4571",
      borderRadius: 90,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderWidth: 3,
      borderColor: theme.palette.mode === "dark" ? "#5460A8" : "#0E4571",
      borderRadius: 90,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderWidth: theme.palette.mode === "dark" ? 3 : 1,
    borderRadius: 90,
    borderColor: theme.palette.mode === "dark" ? "#E6E0E9" : "#0E4571",
  },
}));

type TProps = {
  activeStep: number;
};

export default function HorizontalLinearStepper({ activeStep }: TProps) {
  const theme = useTheme();

  const stepIcon = (props: StepIconProps) => {
    const { active, completed, icon } = props;

    if (icon === 3) {
      return theme.palette.mode === "dark" ? <DarkGiftIcon /> : <GiftIcon />;
    }
    if (active) {
      return theme.palette.mode === "dark" ? (
        <DeactiveStepIcon />
      ) : (
        <ActiveStepIcon />
      );
    } else if (completed) {
      return theme.palette.mode === "dark" ? (
        <DarkActiveStepIcon />
      ) : (
        <CompletedStepIcon />
      );
    } else {
      return <DeactiveStepIcon />;
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      paddingTop={5}
      sx={{
        marginBottom: { xs: "50px", md: "0" },
      }}
    >
      <Box sx={{ width: { xs: "100%", md: "64%" } }}>
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          sx={{ alignItems: "center" }}
          connector={<QontoConnector />}
        >
          {steps.map((label, index) => {
            return (
              <Step key={label}>
                <StepLabel StepIconComponent={stepIcon}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Box>
    </Box>
  );
}
